/**
 * GLL-18 client AU pump for wall / map mini.
 * Soft≠Live: never invent pixels. One outstanding pull. Monotonic PTS.
 *
 * The old hosts used setInterval(tick, 400) while wait_ms=280 long-parked,
 * and EncodedVideoChunk timestamp = Date.now()*1000 — overlapping pulls
 * plus jumped PTS is the live-cam stutter.
 */

export const AU_WAIT_MS_MINI = 280;
export const AU_EMPTY_FLOOR_MS = 48;
export const AU_TS_STEP_US = 33000;
export const AU_LAGGY_QUEUE = 8;
export const AU_SERVED_PARK_MS = 70;

export function clientFloorMs(servedMs, waitMs) {
  const w = Math.max(0, Number(waitMs) || 0);
  const s = Math.max(0, Number(servedMs) || 0);
  if (w > 0 && s >= w * 0.5) return 0;
  return 8;
}

export function nextGapMs(servedMs, { waitMs = AU_WAIT_MS_MINI, emptyFloorMs = AU_EMPTY_FLOOR_MS } = {}) {
  const floor = clientFloorMs(servedMs, waitMs);
  if (floor === 0 || servedMs >= AU_SERVED_PARK_MS) return 0;
  return Math.max(floor, emptyFloorMs);
}

export function b64ToU8(b64) {
  const bin = atob(String(b64 || ""));
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
}

export function annexBIfNeeded(data) {
  const u = data || new Uint8Array(0);
  if (u[0] === 0 && u[1] === 0 && (u[2] === 1 || (u[2] === 0 && u[3] === 1))) {
    return u;
  }
  const sc = new Uint8Array(4 + u.length);
  sc.set([0, 0, 0, 1]);
  sc.set(u, 4);
  return sc;
}

export function shouldDropDelta(needKey, isKey, laggy) {
  if (needKey && !isKey) return true;
  if (laggy && !isKey) return true;
  return false;
}

/**
 * Single-flight continuum. Soft≠ setInterval stampede.
 * @param {{ tick: () => Promise<void>, isDead: () => boolean, emptyFloorMs?: number, waitMs?: number, onGap?: (id:number) => void }} opts
 */
export function startSingleFlightAuLoop({
  tick,
  isDead,
  emptyFloorMs = AU_EMPTY_FLOOR_MS,
  waitMs = AU_WAIT_MS_MINI,
  onGap,
}) {
  let gap = 0;
  const loop = async () => {
    if (isDead()) return;
    const t0 = typeof performance !== "undefined" ? performance.now() : Date.now();
    try {
      await tick();
    } catch {
      /* fail closed Soft≠ invent Soft frames */
    }
    if (isDead()) return;
    const served = (typeof performance !== "undefined" ? performance.now() : Date.now()) - t0;
    const floor = nextGapMs(served, { waitMs, emptyFloorMs });
    gap = setTimeout(loop, floor);
    if (onGap) onGap(gap);
  };
  loop();
  return () => {
    try {
      clearTimeout(gap);
    } catch {
      /* */
    }
  };
}
